import { render, staticRenderFns } from "./OpenSpaceList.vue?vue&type=template&id=58a44c18&scoped=true"
import script from "./OpenSpaceList.vue?vue&type=script&lang=js"
export * from "./OpenSpaceList.vue?vue&type=script&lang=js"
import style0 from "./OpenSpaceList.vue?vue&type=style&index=0&id=58a44c18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a44c18",
  null
  
)

export default component.exports